/**
 * ToggleSwitch — pill CSS nativo, API identica a Shadcn <Switch>.
 * Sostituisce il componente Shadcn che si deformava dentro flex/scale.
 */
export const ToggleSwitch = ({ checked, onCheckedChange, className = "", "data-testid": testId, id, disabled }) => (
  <div
    id={id}
    data-testid={testId}
    role="switch"
    aria-checked={!!checked}
    tabIndex={0}
    onClick={() => !disabled && onCheckedChange && onCheckedChange(!checked)}
    onKeyDown={e => (e.key === " " || e.key === "Enter") && !disabled && onCheckedChange && onCheckedChange(!checked)}
    className={`relative flex-shrink-0 w-11 h-6 rounded-full transition-colors duration-200 cursor-pointer outline-none focus-visible:ring-2 focus-visible:ring-offset-1 focus-visible:ring-primary ${
      checked ? "bg-emerald-500" : "bg-gray-300"
    } ${disabled ? "opacity-50 cursor-not-allowed" : ""} ${className}`}
  >
    <span
      className={`absolute top-1 w-4 h-4 bg-white rounded-full shadow transition-transform duration-200 ${
        checked ? "translate-x-6" : "translate-x-1"
      }`}
    />
  </div>
);

export default ToggleSwitch;
